import http from '@/api/http';
import { serialize } from '@/utils/format';

export async function userStats(token) {
    try {
        const response = await http.get('api/dashboard/statistic/box-user',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}


export async function listSpaces(token) {
    try {
        const response = await http.get('api/dashboard/company/list-all-two-box',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function listProjects(token) {

    try {

        // console.log(query);

        const response = await http.get('api/dashboard/project/list',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function projectInfo(token, id) {
    try {
        const dataParam = {
            id: id
        }
        const response = await http.get('api/dashboard/project/one-details?' + serialize(dataParam),
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }    
}

export async function projectTeam(token, id) {
    try {
        const dataParam = {
            id: id
        }
        const response = await http.get('api/dashboard/statistic/table-team?' + serialize(dataParam),
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }    
}

export async function listTasks(token, data) {

    try {

        const dataParam = {
            count: data.count,
            page: data.page
        }

        const response = await http.get('api/dashboard/task/list?' + serialize(dataParam),
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function listComments(token, id) {

    try {

        const dataParam = {
            project: id
        }

        const response = await http.get('api/dashboard/comment/list?' + serialize(dataParam),
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.log(error.response)
        return null
    }
}
